import { mappers } from './utils';
import { IPublishOfferParams, TPublishOfferResult } from './types';
import { THeaders } from '../../types/request';
import { fetchPublishOffer } from '../../repositories/monolith-python/v2/publish-offer';
import { EPublishOfferErrorCode } from '../../redux/reducers';

export async function publishOffer(params: IPublishOfferParams): Promise<TPublishOfferResult> {
  const { httpApi, logger, parameters, query, subdomain } = params;

  const headers: THeaders = [['Content-Type', 'application/json']];

  const requestConfig = {
    headers,
    subdomain,
  };

  try {
    const response = await fetchPublishOffer({
      httpApi,
      parameters,
      query,
      config: { requestConfig },
      mappers,
    });

    return response as TPublishOfferResult;
  } catch (error) {
    logger.error(error, {
      description: 'Запрос POST /v2/offers/',
      degradation: 'Пользователь не может разместить объявление',
    });

    return {
      success: false,
      statusCode: error.statusCode,
      payload: {
        errorCode: EPublishOfferErrorCode.fatalError,
        errorMessage: 'Что-то пошло не так. Попробуйте повторить позднее',
        errors: null,
      },
    };
  }
}
